@if (redirect =='new') {
  <mat-horizontal-stepper linear="true" #stepper>
    <!-- Step 1 select equipmet -->
    <mat-step [stepControl]="formStepeOne">
      <form [formGroup]="formStepeOne">
        <ng-template class="font" matStepLabel>{{isChecked?'Selección de equipo':'Seleccione tipo de equipo'}}</ng-template>
        <div class="w-100 d-flex flex-column align-items-center">
          <mat-slide-toggle (change)="changeToggle($event)">{{!isChecked?'Equipos':'Tipo de equipos'}}</mat-slide-toggle>
          <!-- Select equipment -->
          @if (!isChecked) {
            <div class="w-100 d-flex flex-row align-items-center">
              <div style="width:50%;">
                <data-table title='' [columns]='columnasEquipos' [configuration]='configurationEquipos'
                  [reloadTable]='recargarTablaEquipos' (clickRow)='clickRowEquipment($event)' [params]='[]'
                  [url]='urlTableEquipments'>
                </data-table>
              </div>
              @if (equipment) {
                <div style="width:50%; text-align: center">
                  <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
                  <h2 style="margin-top: 5px;">serial: {{equipment.serial}}</h2>
                </div>
              }
            </div>
          }
          <!-- Select equipment type -->
          @if (isChecked) {
            <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
              <app-button-label class="mt-3" [labels]="[equipmentType?.name]"> </app-button-label>
              <div style="width: 100%;">
                <data-table title='' [columns]='columnasTipoEquipo' [configuration]='configurationTipoEquipo'
                  [reloadTable]='recargarTablaTipoEquipo' (clickRow)='clickRowEquipmentType($event)' [params]='[]'
                  [url]='urlTableEquipmentType'>
                </data-table>
              </div>
            </div>
          }
          @if (equipmentType || equipment) {
            <button matStepperNext style="width: 70%; margin-top: 15px;" color="primary"
            class="button-save mat-elevation-z5 " mat-raised-button>Continuar</button>
          }
          <div style="display: none">
            <mat-form-field>
              <input autocomplete="off" type="text" formControlName='id' matInput required>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-step>
    <!-- Step 2 form -->
    <mat-step [stepControl]="formRegistry">
      <ng-template class="font" matStepLabel>Formulario</ng-template>
      <ng-container *ngTemplateOutlet="formActivity"></ng-container>
    </mat-step>
    <!-- Step 3 resources -->
    @if (inventoryModule) {
      <mat-step>
        <ng-template class="font" matStepLabel>Recursos</ng-template>
        <app-handler-items (listItemComplete)="createActivityWithResources($event)"
          (comboItemLength)="comboItemsLength($event)" [titleDialog]="'Recursos'" [headerDetails]="false"
          [acceptButton]="true" [labelAcceptButton]="!isChecked?'Guardar':'Continuar'" [initializeEmptyItem]="true" [urlItemCombo]="urlGetItems">
        </app-handler-items>
      </mat-step>
    }
    @if (equipmentType) {
      <mat-step>
        <ng-template class="font" matStepLabel>Formulario equipos</ng-template>
        <form (ngSubmit)="createActivityBulk()">
          @for (item of equipmentsByEquipmentType; track item; let i = $index) {
            <div>
              <div class="first-row">
                <div class="row-item">
                  <mat-form-field>
                    <mat-label>código</mat-label>
                    <input readonly matInput placeholder="código" [value]="item.code">
                  </mat-form-field>
                </div>
                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Medidor actual (horas/km/ciclos)</mat-label>
                    <input type="text" readonly matInput placeholder="Medidor actual (horas/km/ciclos)" [value]="item.currentOdometer | thousandSeparator">
                  </mat-form-field>
                </div>
                <div class="row-item">
                  <mat-form-field>
                    <mat-label>{{item.components?.length > 0 ? 'Componentes' : 'No tiene Componentes'}}</mat-label>
                    <mat-select [(ngModel)]="activityFromByEquipmetType[i].componentId" [ngModelOptions]="{standalone: true}">
                      @for (item of item.components; track item) {
                        <mat-option value={{item.id}}>
                        {{item.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Medidor última actividad (horas/km/ciclos)</mat-label>
                    <input type="text" appThousandSeparator matInput placeholder="Medidor última actividad (horas/km/ciclos)"
                      [(ngModel)]="activityFromByEquipmetType[i].odometerLastMtto" [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>
                <div class='row-item'>
                  <mat-form-field [appOpenDatepickerOnClick]="pickerNextMtto">
                    <mat-label>Fecha próxima actividad</mat-label>
                    <input required matInput [matDatepicker]="pickerNextMtto" autocomplete="off" matInput
                      [(ngModel)]="activityFromByEquipmetType[i].lastMttoDate" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerNextMtto">
                    </mat-datepicker-toggle>
                    <mat-datepicker #pickerNextMtto [touchUi]='movil?true:false'></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          }
          <div style="width: 100%;  margin:50px 0 30px 0; display:flex; justify-content: center;">
            <button style="width: 70%;" color="primary" class="button-save mat-elevation-z5 " mat-raised-button
            type="submit">Guardar</button>
          </div>
        </form>
      </mat-step>
    }
  </mat-horizontal-stepper>
}

@if (redirect == 'edit') {
  <mat-tab-group class="m-5">
    <mat-tab label="Formulario">
      <ng-container *ngTemplateOutlet="formActivity"></ng-container>
    </mat-tab>
    <!-- mat 3 Resources-->
    @if (inventoryModule) {
      <mat-tab
        label="Recursos">
        <div class="mt-5">
          @if (redirect =='edit') {
            <data-table label="Recursos"
              [title]='"Recursos Actividad"'
              [columns]='columnsResouces'
              [configuration]='configurationResouces'
              [reloadTable]='reloadResouces'
              [url]='urlGetTableResourcesActivity'
              [params]='paramsResources'
              (delete)='deleteResources($event)'
              (add)='addResources($event)'
              (edit)='editResources($event)'
              (internalData)="dataResources($event)">
            </data-table>
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
}

<ng-template #formActivity>
  <form [formGroup]="formRegistry" (ngSubmit)="formRegistry.valid?saveForm(formRegistry.value):errorForm()">

    <div class="d-flex w-100 mt-4 activitie-detail-wrapper">
      <div [style.flex]="redirect == 'edit'? 10 : 12 " style="min-width:0;">

        <div class="first-row activitie-detail-row">
          <div class="row-item">
            <mat-form-field>
              <mat-label>Código</mat-label>
              <input readonly matInput placeholder="Código" [value]="equipment?.code??equipmentType?.name">
            </mat-form-field>
          </div>

          @if (equipment) {
            <div class="row-item">
              <mat-form-field>
                <mat-label>Medidor actual (horas/km/ciclos)</mat-label>
                <input type="text" readonly matInput placeholder="Medidor actual (horas/km/ciclos)" [value]="equipment?.currentOdometer | thousandSeparator">
              </mat-form-field>
            </div>
          }

          @if (equipment) {
            <div class="row-item">
              <mat-form-field>
                <mat-label>Componentes</mat-label>
                <mat-select formControlName="componentId">
                  @for (item of equipment?.components; track item) {
                    <mat-option [value]="item.id">
                    {{item.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }



          @if (equipment) {
            <div class='row-item'>
              <mat-form-field [appOpenDatepickerOnClick]="pickerDateNextMtto">
                <mat-label>Fecha próxima actividad</mat-label>
                <input [required]="formStepeOne.get('id').value" matInput [matDatepicker]="pickerDateNextMtto" autocomplete="off" matInput
                  formControlName='lastMttoDate' >
                <mat-datepicker-toggle matIconSuffix [for]="pickerDateNextMtto">
                </mat-datepicker-toggle>
                <mat-datepicker #pickerDateNextMtto [touchUi]='movil?true:false'></mat-datepicker>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
          }

        </div>

        <div class="default-row activitie-detail-row">

          @if (equipment) {
            <div class="row-item">
              <mat-form-field>
                <mat-label>Medidor última actividad (horas/km/ciclos)</mat-label>
                <input type="text" appThousandSeparator formControlName='odometerLastMtto' matInput placeholder="Medidor última actividad (horas/km/ciclos)"
                  #ultimoMtto oninput="this.value = this.value.slice(0,10)">
                <mat-hint>{{ultimoMtto.value.length}}/10</mat-hint>
                @if (equipment.currentOdometer > 0) {
                  <mat-error>Campo requerido</mat-error>
                }
              </mat-form-field>
            </div>
          }

          <div class="row-item">
            <mat-form-field>
              <mat-label>Frecuencia uso (horas/km/ciclos)</mat-label>
              <input type="text" appThousandSeparator formControlName='odometerFrequency' matInput
                placeholder="Frecuencia uso (horas/km/ciclos)" #frecuenciaOdometro oninput="this.value = this.value.slice(0,10)">
              <mat-hint>{{frecuenciaOdometro.value.length}}/10</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <mat-label>Frecuencia Tiempo (dias)</mat-label>
              <input type="number" required formControlName='timeFrequency' matInput
                placeholder="Frecuencia Tiempo (dias)" #frecuenciaTiempo oninput="this.value = this.value.slice(0,10)">
              <mat-hint>{{frecuenciaTiempo.value.length}}/10</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <mat-label>Costo</mat-label>
              <input required type="text" appThousandSeparator formControlName='cost' matInput placeholder="Costo" #costo
                oninput="this.value = this.value.slice(0,15)">
              <mat-hint>{{costo.value.length}}/15</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

        </div>

        @if (!inventoryModule) {
          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Recursos</mat-label>
                <input autocomplete="off" type="text" formControlName='resources' matInput placeholder="Recursos" #recurso
                  maxlength="255">
                <mat-hint>{{recurso.value.length}}/255</mat-hint>
              </mat-form-field>
            </div>
          </div>
        }

        <div class="default-row activitie-detail-row">

          <div class='row-item'>

            <mat-form-field>
              <mat-label>Procedimiento</mat-label>
              <textarea
                autocomplete="off"
                formControlName="description"
                matInput
                #descripcion
                rows="3"
                maxlength="10000"
                placeholder="Procedimiento"
                class="min-rows-2 resizable-textarea"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="15"
              ></textarea>
              <mat-hint>{{ descripcion.value.length }}/10000</mat-hint>
            </mat-form-field>

          </div>
        </div>

      </div>

      @if (redirect == 'edit') {
        <div style='flex:.2; min-width: 60px;'>
          <button mat-mini-fab color="warn" type="submit">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-mini-fab color="accent" (click)='deleteActivity($event)' style='margin-top: 10px;'>
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-mini-fab color="primary" (click)='back($event)' style='margin-top: 10px;'>
            <mat-icon>reply</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (redirect == 'new') {
      <div style="width: 100%;  margin-top: 50px; display:flex; justify-content: center;">
        <button style="width: 70%;" color="primary" class="button-save mat-elevation-z5 " mat-raised-button
        type="submit">{{!isChecked && !inventoryModule?'Guardar':'Continuar'}}</button>
      </div>
    }

  </form>
</ng-template>
